const MasterData = Object.freeze({
  DataComplementary: 0,
  OwnershipTypes: 1,
  QualityProtocols: 2,
  Campaigns: 3,
  Varieties: 4,
  Countries: 5,
  Farmers: 6,
  Fields: 7,
  Crops: 8,
  Contracts: 9,
  FamiliesOfVarieties: 10,
  WayToPay: 11,
  Retention: 12,
  Business: 13,
  VatRate: 14,
  Zones: 15,
});

export { MasterData };
